<template>
  <div class="table-scroll">
    <table :class="['ui table', tableClass, tableCells]">
      <thead>
        <tr>
          <th v-for="(head, index) in headers" :key="index" v-bind:class="head.tdClass">{{ head.text }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" :class="item.statusRow">
          <td v-for="(head, index) in headers" :key="index" v-bind:class="[head.tdClass, item.tdClass]">
            <template v-if="head.link">
              <router-link
                :to="item[head.value]"
                :class="item.btnClass"
              >
                {{ head.text }}
              </router-link>
            </template>
            <template v-if="head.linkExterno && item[head.value]">
              <a
                target="_blank"
                :class="[{ 'ui link green compact small': !item.btnClass }, item.btnClass]"
                :href="item[head.value]"
              >
                {{ head.text }}
              </a>
            </template>
            <template v-if="head.buttons">
              <button
                v-for="(button, index) in item[head.value]"
                :key="index"
                @click="button.click"
                :class="button.class"
                :disabled="button.disabled"
                :data-tooltip="button.tooltip"
                data-position="top right"
                type="button"
              >
                <i v-if="button.icon" :class="button.icon"></i>
                {{ button.text }}
              </button>
            </template>
            <template v-if="!head.link && !head.buttons && !head.linkExterno">
              <span v-html="item[head.value]"></span>
            </template>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th v-for="(footer, index) in footers" :key="index" v-bind:class="footer.class" :colspan="footer.colspan">{{ footer.text }}</th>
        </tr>
        </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SimpleTable',
  props: ['headers', 'items', 'footers', 'tableClass', 'cells'],
  data() {
    return {
      tableCells: this.cells ? this.cells : 'celled',
    };
  },
};
</script>

<style lang="scss">
  .table-scroll {
    overflow-x: auto;
  }
</style>
